export class StringUtils {
    static formatPhoneNumber(phone) {
        if (!phone) return "";
        phone = String(phone).replace(/\D/g, "");
        if (phone.length === 10) {
            phone = String(phone).replace(
                /(\d{2})(\d{4})(\d{4})/,
                "($1) $2-$3"
            );
        } else if (phone.length === 11) {
            phone = String(phone).replace(
                /(\d{2})(\d{5})(\d{4})/,
                "($1) $2-$3"
            );
        }

        return phone;
    }

    static stringMaskApply(value, pattern, options) {
        if (!value || !pattern) return value || "";
        value = String(value).replace(/[^\dA-Za-z]/g, "");

        const tokens = {
            0: { pattern: /\d/, _default: "0" },
            9: { pattern: /\d/, optional: true },
            "#": { pattern: /\d/, optional: true, recursive: true },
            A: { pattern: /[a-zA-Z0-9]/ },
            N: {
                pattern: /[a-zA-Z0-9]/,
                transform: function (c) {
                    return c.toLocaleUpperCase();
                }
            },
            S: { pattern: /[a-zA-Z]/ },
            U: {
                pattern: /[a-zA-Z]/,
                transform: function (c) {
                    return c.toLocaleUpperCase();
                }
            },
            L: {
                pattern: /[a-zA-Z]/,
                transform: function (c) {
                    return c.toLocaleLowerCase();
                }
            },
            $: { escape: true }
        };

        function isEscaped(pattern, pos) {
            let count = 0;
            let i = pos - 1;
            let token = { escape: true };
            while (i >= 0 && token && token.escape) {
                token = tokens[pattern.charAt(i)];
                count += token && token.escape ? 1 : 0;
                i--;
            }
            return count > 0 && count % 2 === 1;
        }

        function calcOptionalNumbersToUse(pattern, value) {
            const numbersInP = pattern.replace(/[^0]/g, "").length;
            const numbersInV = value.replace(/[^\d]/g, "").length;
            return numbersInV - numbersInP;
        }

        function concatChar(text, character, options, token) {
            if (token && typeof token.transform === "function") {
                character = token.transform(character);
            }
            return options.reverse ? character + text : text + character;
        }

        function hasMoreTokens(pattern, pos, inc) {
            const pc = pattern.charAt(pos);
            const token = tokens[pc];
            if (pc === "") return false;
            return token && !token.escape
                ? true
                : hasMoreTokens(pattern, pos + inc, inc);
        }

        function hasMoreRecursiveTokens(pattern, pos, inc) {
            const pc = pattern.charAt(pos);
            const token = tokens[pc];
            if (pc === "") return false;
            return token && token.recursive
                ? true
                : hasMoreRecursiveTokens(pattern, pos + inc, inc);
        }

        function insertChar(text, char, position) {
            const t = text.split("");
            t.splice(position, 0, char);
            return t.join("");
        }

        options = {
            reverse: !!(options && options.reverse),
            usedefaults: !!(
                (options && options.usedefaults) ??
                (options && options.reverse)
            )
        };

        let pattern2 = pattern;
        let formatted = "";
        let valuePos = options.reverse ? value.length - 1 : 0;
        let patternPos = 0;
        let optionalNumbersToUse = calcOptionalNumbersToUse(pattern2, value);
        let escapeNext = false;
        let recursive = [];
        let inRecursiveMode = false;

        const steps = {
            start: options.reverse ? pattern2.length - 1 : 0,
            end: options.reverse ? -1 : pattern2.length,
            inc: options.reverse ? -1 : 1
        };

        function continueCondition() {
            if (
                !inRecursiveMode &&
                !recursive.length &&
                hasMoreTokens(pattern2, patternPos, steps.inc)
            ) {
                return true;
            } else if (
                !inRecursiveMode &&
                recursive.length &&
                hasMoreRecursiveTokens(pattern2, patternPos, steps.inc)
            ) {
                return true;
            } else if (!inRecursiveMode) {
                inRecursiveMode = recursive.length > 0;
            }
            if (inRecursiveMode) {
                const pc = recursive.shift();
                recursive.push(pc);
                if (options.reverse && valuePos >= 0) {
                    patternPos++;
                    pattern2 = insertChar(pattern2, pc, patternPos);
                    return true;
                } else if (!options.reverse && valuePos < value.length) {
                    pattern2 = insertChar(pattern2, pc, patternPos);
                    return true;
                }
            }
            return patternPos < pattern2.length && patternPos >= 0;
        }

        for (
            patternPos = steps.start;
            continueCondition();
            patternPos = patternPos + steps.inc
        ) {
            const vc = value.charAt(valuePos);
            const pc = pattern2.charAt(patternPos);
            let token = tokens[pc];
            if (recursive.length && token && !token.recursive) {
                token = null;
            }

            if (!token && valuePos < value.length) {
                formatted = concatChar(formatted, pc, options, token);
                if (!inRecursiveMode && recursive.length) {
                    recursive.push(pc);
                }
            } else if (token && token.pattern && token.pattern.test(vc)) {
                formatted = concatChar(formatted, vc, options, token);
                valuePos = valuePos + steps.inc;
            } else {
                break;
            }
        }

        return formatted;
    }
}
